import { ToggleButton, ToggleButtonGroup } from "@heroui/react";
import type { Key } from "@heroui/react";

interface IngredientScalerProps {
    /** Current multiplier applied to ingredient quantities. */
    value: number;
    onChange: (multiplier: number) => void;
}

/** ½× / 1× / 2× selector that rescales the ingredient amounts. */
export const IngredientScaler = ({ value, onChange }: IngredientScalerProps) => {
    const handleSelectionChange = (keys: Set<Key>) => {
        const [key] = keys;
        if (key !== undefined) onChange(Number(key));
    };

    return (
        <ToggleButtonGroup
            selectionMode="single"
            disallowEmptySelection
            size="sm"
            selectedKeys={[String(value)]}
            onSelectionChange={handleSelectionChange}
            aria-label="Scale ingredient amounts"
        >
            <ToggleButton id="0.5">½×</ToggleButton>
            <ToggleButton id="1">
                <ToggleButtonGroup.Separator />
                1×
            </ToggleButton>
            <ToggleButton id="2">
                <ToggleButtonGroup.Separator />
                2×
            </ToggleButton>
        </ToggleButtonGroup>
    );
};
